module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-adminlinks"
  }, [_c('div', {
    staticClass: "pages-adminlinks__content"
  }, [(_vm.props.acf.page_title) ? _c('h2', {
    staticClass: "pages-adminlinks__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.page_title)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "pages-adminlinks__list"
  }, _vm._l((_vm.props.acf.page_links_lists), function(lists, i) {
    return _c('div', {
      staticClass: "pages-adminlinks__listitem"
    }, [_c('router-link', {
      attrs: {
        "to": lists.links
      },
      domProps: {
        "innerHTML": _vm._s("https://www.mattiacioortho.com" + lists.links)
      }
    })], 1)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e180b45","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/admin-links/admin-links.pug
// module id = 709
// module chunks = 1